import React from "react";
import { Segmented, Tooltip } from "src/assets/imports/antdComponents";
import { useTranslation } from "react-i18next";

interface ChartViewToggleProps {
	isChartView: boolean;
	setIsChartView: (value: boolean) => void;
}

const ChartViewToggle: React.FC<ChartViewToggleProps> = ({ isChartView, setIsChartView }) => {
	const { t } = useTranslation();

	return (
		<Segmented
			options={[
				{
					label: (
						<Tooltip title={t("Chart View")}>
							<i aria-label="chart-option" className="material-symbols-outlined text-[1.5rem] h-full flex items-center justify-center">
								monitoring
							</i>
						</Tooltip>
					),
					value: "chart",
				},
				{
					label: (
						<Tooltip title={t("Tabular View")}>
							<i aria-label="table-option" className="material-symbols-outlined text-[1.5rem] h-full flex items-center justify-center">
								data_table
							</i>
						</Tooltip>
					),
					value: "table",
				},
			]}
			className="dashboard-chart-table-toggle-segmented"
			value={isChartView ? "chart" : "table"}
			onChange={(val) => {
				if (val === "chart" || val === "table") {
					setIsChartView?.(val === "chart");
				}
			}}
			size="small"
			aria-label={t("Toggle between chart and table view")}
		/>
	);
};

export default ChartViewToggle;
